<div class="thermometer-container">
    <div class="colors">
        <div class="color-container">
            <img *ngIf="color1" src="./assets/thermo/color_1.svg" [ngStyle]="{left: value}" alt="">
            <div class="color-1"></div>
        </div>
        <div class="color-container">
            <img *ngIf="color2" src="./assets/thermo/color_2.svg" [ngStyle]="{left: value}" alt="">
            <div class="color-2"></div>
        </div>
        <div class="color-container">
            <img *ngIf="color3" src="./assets/thermo/color_3.svg" [ngStyle]="{left: value}" alt="">
            <div class="color-3"></div>
        </div>
        <div class="color-container">
            <img *ngIf="color4" src="./assets/thermo/color_4.svg" [ngStyle]="{left: value}" alt="">
            <div class="color-4"></div>
        </div>
    </div>
    <div class="scale">
        <div class="min">{{min}}</div>
        <div class="max">{{max}}</div>
    </div>
</div>